<template>
  <div style="width:100%">
    <div class="activityDrawListSearch timeWidth">
      <el-row class="ListMenu">
        <el-col>
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForms searchFormPaddings"
          >
            <el-form-item label="會員帳號" class="searchItem">
              <el-input
                placeholder="请输入會員帳號"
                v-model="listMenuForm.userEmail"
              ></el-input>
            </el-form-item>
            <!-- v-if="shouldlarge" -->
            <el-form-item label="地區" class="searchItem">
              <el-select
                v-model="listMenuForm.selectArea"
                placeholder="请选择地區"
                @change="selectAreaChange"
              >
                <el-option
                  v-for="item in Areaoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- v-if="shouldlarge" -->
            <el-form-item
              label="詳細地區"
              v-if="listMenuForm.selectArea"
              class="searchItem"
            >
              <el-input
                v-model="listMenuForm.areaDetail"
                placeholder="請輸入詳細地址，如上海"
              ></el-input>
            </el-form-item>
            <el-form-item label="VIP開始日期早于" class="searchItems">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time1"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="VIP開始日期晚于"
              class="searchItems"
              v-if="showchange && !listMenuForm.selectArea"
            >
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time2"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="黑名單" class="searchItem" v-if="shouldlarge">
              <el-select
                v-model="listMenuForm.isBlack"
                placeholder="請選擇是否為黑名單"
              >
                <el-option label="是" value="2"></el-option>
                <el-option label="否" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row class="ListMenu">
        <el-col>
          <el-form ref="form" :model="listMenuForm" class="searchFormtwo">
            <el-form-item
              label="VIP開始日期晚于"
              class="searchItems"
              v-if="!showchange || listMenuForm.selectArea"
            >
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="listMenuForm.time2"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="付款狀態"
              class="searchItem"
              v-if="this.paymessage.free == 1"
            >
              <el-select v-model="listMenuForm.paystatus" placeholder="全部">
                <el-option label="已付款" value="2"></el-option>
                <el-option label="未付款" value="1"></el-option>
                <el-option label="已過期" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="黑名單" class="searchItem" v-if="!shouldlarge">
              <el-select
                v-model="listMenuForm.isBlack"
                placeholder="請選擇是否為黑名單"
              >
                <el-option label="是" value="2"></el-option>
                <el-option label="否" value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="index == 0 ? '徽章' : ''"
              class="searchItem searchbage"
              v-for="(badges, index) in listMenuForm.badge"
              :key="index"
            >
              <el-select
                v-model="badges.badgeType"
                placeholder="請選擇徽章"
                @change="BadgeoptionsChange(badges.badgeType, index)"
              >
                <el-option
                  v-for="item in Badgeoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="badges.badgeLevel"
                placeholder="請選擇徽章等級"
                style="margin-left:10px"
              >
                <el-option
                  v-for="item in BadgeLeveloptions[index]"
                  :key="item.id"
                  :label="item.grade"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span
                v-show="!(index === 0)"
                style="color:#6C3DEA;cursor: pointer;"
                @click="
                  delGoodsItem(index, listMenuForm.badge, BadgeLeveloptions)
                "
                >删除</span
              >
              <i
                v-if="index === listMenuForm.badge.length - 1"
                class="el-icon-circle-plus-outline"
                @click="addbadges()"
              ></i>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="MenuBtnWrap_right" style="margin-right:16px">
        <div class="btn" @click="search()" style="marginRight:0.2rem">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
    </div>
    <div class="activityDrawListTable">
      <div class="statusbar">
        <div>
          <div
            class="statusbar_left"
            v-if="this.paymessage.applyStatus == 5"
            style="margin-left: 15px;"
          >
            <div>已選擇（跨頁）</div>
            <div style="color:rgba(108, 61, 234, 1)">
              {{ checkboxList.length }} 項
            </div>
          </div>
          <div
            style="width: 100%;display: flex; justify-content: start;margin-top: 10px;"
            v-if="this.paymessage.free == 1"
          >
            <div class="statusbar_top" style="margin-left: 16px;">
              付款金額：{{ this.paymessage.price }} CNY/{{
                this.paymessage.twdPrice
              }}TWD
            </div>
            <div class="statusbar_top">
              付款結束時間：{{ this.$getTime(paymessage.orderOutTime) }}
            </div>
            <div class="statusbar_top">
              已付款人數：{{ paymessage.payNumber }}
            </div>
            <div class="statusbar_top">
              未付款人數：{{ paymessage.noPayNumber }}
            </div>
          </div>
        </div>
        <div class="statusbar_right">
          <div class="btn btnPur" @click="handleDownloadExcel">
            下載中選名單
          </div>
          <div
            class="btn btnPur"
            @click="blackShow"
            v-if="this.paymessage.applyStatus == 5"
          >
            加入黑名單
          </div>
          <div
            class="btn"
            @click="endPay"
            v-if="this.paymessage.applyStatus == 4"
          >
            結束付款
          </div>
          <div
            class="btn"
            @click="uploadModal"
            v-if="this.paymessage.applyStatus == 5"
          >
            更新抽取結果
          </div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          ref="multipleTable"
          height="660px"
          :data="tableData"
          style="width: 100%"
          :row-key="row => row.id"
          @select="handleSelect"
          @select-all="selectAll"
          @sort-change="handleSortChange"
          stripe
        >
          <template slot="empty">
            <div class="no-data-container" style="width:80vw">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <!-- v-if="this.paymessage.applyStatus == 5" -->
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
            v-if="this.paymessage.free == 0 || this.paymessage.applyStatus == 5"
          >
          </el-table-column>
          <el-table-column
            v-for="(item, index) in activityTable2"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :sortable="item.sortable"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'status2'">
                <div v-if="scope.row.status == 1 || scope.row.status == 6">
                  未付款
                </div>
                <div v-else-if="scope.row.status == 3">已付款</div>
                <div v-else-if="scope.row.status == 4">已取消</div>
                <div v-else-if="scope.row.status == 5">已過期</div>
                <div v-else>-</div>
              </div>
              <div
                v-else-if="!scope.row[item.prop] && scope.row[item.prop] !== 0"
              >
                -
              </div>
              <div
                v-else-if="item.prop === 'status' && item.label == '報名狀態'"
              >
                <div v-if="scope.row.status == 0">待抽籤</div>
                <div v-else-if="scope.row.status == 2">未抽中</div>
                <div
                  v-else-if="
                    scope.row.status == 1 ||
                      scope.row.status == 3 ||
                      scope.row.status == 4 ||
                      scope.row.status == 5 ||
                      scope.row.status == 6
                  "
                  style="color:rgb(108, 61, 234)"
                >
                  已抽中
                </div>
              </div>

              <div v-else>{{ scope.row[item.prop] }}</div>
              <!-- <div>{{ item }}</div> -->
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button @click="navigatetoDetail(scope.row)" type="text"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[20, 50, 100, 200]"
          :current-page="currentPage"
          :page-size="20"
          :pager-count="5"
          layout="sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 取消选中弹窗 -->
    <el-dialog
      title="提示訊息"
      :visible.sync="confirmshow"
      width="5.6rem"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div style="marginTop:30px" class="commonfont">確定要結束付款嗎？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmshow = false">取消</el-button>
        <el-button type="primary" @click="confirmShowModal">確認</el-button>
      </span>
    </el-dialog>
    <!-- 取消选中弹窗 -->
    <el-dialog
      title="提示訊息"
      :visible.sync="blackaddshow"
      width="5.6rem"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div style="text-align:left" class="commonfont">
        <div>
          是否將選中{{
            checkboxList.length
          }}項的用戶加入禁用功能爲活動報名的黑名單，並且將報名狀態更新爲已取消？
        </div>
        <div style="marginTop:30px">
          <span>禁用至：</span>
          <el-date-picker
            v-model="blackendTime"
            type="datetime"
            placeholder="選擇時間"
          ></el-date-picker>
        </div>
        <div class="remark_box_input">
          <div class="remark_box_text">原因 |</div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 4 }"
            placeholder="請輸入加入黑名單原因"
            v-model="blackReason"
            maxlength="300"
          >
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blackaddshow = false">取消</el-button>
        <el-button type="primary" @click="blackaddshowModal">確認</el-button>
      </span>
    </el-dialog>
    <!-- 上传弹窗 -->
    <el-dialog
      title="更新抽取結果"
      :visible.sync="uoloadModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
    >
      <div class="dialog">
        <div>
          <el-upload
            ref="excelUpload"
            :action="this.$GLOBAL.activityPostResultUrl"
            :with-credentials="true"
            class="upload-demo"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            drag
            :accept="'.xlsx,.xls'"
            :multiple="false"
            :file-list="fileList"
            :on-change="fileChange"
            :on-success="successExcel"
            :on-error="errorExcel"
            :auto-upload="false"
            :data="{
              applyId: this.$route.query.id
            }"
          >
            <img
              src="@/assets/images/common/blacklist_upload.png"
              alt="暂无数据"
              :style="{
                width: '41px',
                height: '41px',
                marginTop: '40px',
                marginBottom: '14px'
              }"
            />
            <div class="el-upload__text">
              將文件拖到此處，或<em>點擊上傳</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上傳單個xlsx/xls文件，並且只根據上傳內容進行更新
            </div>
          </el-upload>
          <div class="btngroup">
            <div
              class="btn borderBtn"
              style="marginRight:112px"
              @click="uoloadModal = false"
            >
              取消
            </div>
            <div class="btn" @click="submitupdate">確認更新</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from "@/components/dialog";
export default {
  data() {
    return {
      navBlock: "活動 / 活動列表 ",
      navtitle: "活動抽簽",
      listMenuForm: {
        userEmail: "",
        time1: "",
        time2: "",
        badge: [
          {
            badgeLevel: "",
            badgeType: ""
          }
        ],
        selectStatus: "",
        selectArea: "",
        areaDetail: "",
        isBlack: "",
        paystatus: ""
      },
      dialogVisible: false,
      uoloadModal: false,
      fileList: [],
      currentPage: 1, // 分页
      total: 10,
      currentPageSize: 20,
      checkboxList: [], //所有页面选中编号
      confirmshow: false, //确认弹窗
      blackaddshow: false,
      blackendTime: "", //黑名单截止时间
      blackReason: "", //黑名单原因
      showTip: "",
      shouldlarge: true,
      activityTable2: [],
      activityTable: [
        {
          prop: "status",
          label: "報名狀態",
          width: "170"
        },
        {
          prop: "userId",
          label: "会员ID",
          width: "170"
        },
        {
          prop: "username",
          label: "會員帳號",
          width: "170"
        },

        {
          prop: "applicant",
          label: "申請人",
          width: "170"
        },
        {
          prop: "num",
          label: "張數",
          width: "110"
        },
        {
          prop: "district",
          label: "地區",
          width: "170"
        },
        {
          prop: "vipStartTime",
          label: "VIP起始日",
          width: "170"
        },
        {
          prop: "vipEndTime",
          label: "VIP到期日",
          width: "170"
        },
        {
          prop: "annualSelectNum",
          label: "本年度中選次數",
          width: "170"
        },
        {
          prop: "sameTypeSelectNum",
          label: "同類型中選次數",
          width: "150"
        },
        {
          prop: "remark",
          label: "報名備註",
          width: "250"
        },
        {
          prop: "applyResult",
          label: "申請結果",
          width: "170"
        }
      ],
      activityTable1: [
        {
          prop: "status",
          label: "報名狀態",
          width: "170"
        },

        {
          prop: "status2",
          label: "付款狀態",
          width: "170"
        },
        {
          prop: "userId",
          label: "會員編號",
          width: "170"
        },
        {
          prop: "username",
          label: "會員帳號",
          width: "170"
        },
        {
          prop: "applicant",
          label: "申請人",
          width: "170"
        },
        {
          prop: "num",
          label: "張數",
          width: "110"
        },
        {
          prop: "district",
          label: "地區",
          width: "170"
        },
        {
          prop: "vipStartTime",
          label: "VIP起始日",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "vipEndTime",
          label: "VIP到期日",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "annualSelectNum",
          label: "本年度中選次數",
          width: "170",
          sortable: "custom"
        },
        {
          prop: "sameTypeSelectNum",
          label: "同類型中選次數",
          width: "150",
          sortable: "custom"
        },
        {
          prop: "remark",
          label: "報名備註",
          width: "250"
        },
        {
          prop: "applyResult",
          label: "申請結果",
          width: "170"
        }
      ],
      //地区选择框
      Areaoptions: [
        {
          value: "1",
          label: "中國大陸"
        },
        {
          value: "2",
          label: "港澳臺"
        },
        {
          value: "3",
          label: "海外"
        }
      ],
      //徽章选择框
      Badgeoptions: [],
      BadgeLeveloptions: [{}],
      BadgeoptionsSum: [],
      tableData: [],
      isActivate: false, //详情缓存，非详情手刷
      sortType: "",
      sortValue: "",
      showchange: true,
      paymessage: {
        applyStatus: 4
      },
      showbtn: false
    };
  },
  created() {
    this.initpage();
    //手动清除整个页面，从列表处打开需要触发
    this.$bus.$on("activityDrawConfirminit", () => {
      Object.assign(this.$data, this.$options.data());
      this.isActivate = false;
      this.initpage();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  destroyed() {
    this.$bus.$off("activityDrawConfirminit");
  },
  activated() {
    if (this.isActivate) {
      this.initpage();
    }
  },
  deactivated() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    checkSelectable(row) {
      if (this.paymessage.free == 1) {
        if (row.status == 1 || row.status == 3 || row.status == 5) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    delGoodsItem(index, list, list2) {
      list.splice(index, 1);
      list2.splice(index, 1);
    },
    addbadges() {
      const _this = this;
      let length = _this.listMenuForm.badge.length;
      _this.listMenuForm.badge.push({
        badgeLevel: "",
        badgeType: ""
      });
    },
    initpage() {
      // this.BadgeInit()
      this.getList();
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    },
    handleResize() {
      let a =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.shouldlarge = a > 1919;
      this.showchange = a > 1500;
    },
    //徽章处理
    BadgeInit() {
      this.$get("/request/badge/all").then(res => {
        if (res.code == "00000") {
          this.BadgeoptionsSum = res.data;
          let current = [];
          res.data.forEach(item => {
            current.push({ label: item.name, value: item.name });
          });
          this.Badgeoptions = current;
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    getList() {
      let _this = this;
      let param = {
        applyId: this.$route.query.id,
        status: 1
      };
      //賬號
      if (_this.listMenuForm.userEmail) {
        param = {
          ...param,
          username: _this.listMenuForm.userEmail
        };
      }
      // 開始時間
      if (_this.listMenuForm.time1) {
        let startTime = this.$formatDate(_this.listMenuForm.time1);
        param = {
          ...param,
          vipStartTime: startTime
        };
      }
      // 結束時間
      if (_this.listMenuForm.time2) {
        let endTime = this.$formatDate(_this.listMenuForm.time2);
        param = {
          ...param,
          vipEndTime: endTime
        };
      }
      // 付款狀態
      if (_this.listMenuForm.paystatus) {
        param = {
          ...param,
          payStatus: Number(_this.listMenuForm.paystatus)
        };
      }
      let badgeId = [];
      if (_this.listMenuForm.badge[0].badgeType) {
        for (let i = 0; i < _this.listMenuForm.badge.length; i++) {
          if (!_this.listMenuForm.badge[i].badgeType) {
            this.dialogVisible = true;
            this.$propMessage("请選擇徽章", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else if (!_this.listMenuForm.badge[i].badgeLevel) {
            this.dialogVisible = true;
            this.$propMessage("選擇徽章後請選擇徽章等級", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else {
            badgeId.push(_this.listMenuForm.badge[i].badgeLevel);
            param = {
              ...param,
              badgeId: badgeId.toString()
            };
          }
        }
      }
      // 地區
      if (_this.listMenuForm.selectArea) {
        param = {
          ...param,
          district: Number(_this.listMenuForm.selectArea),
          address: _this.listMenuForm.areaDetail
            ? _this.listMenuForm.areaDetail
            : null
        };
      }
      // 黑名單
      if (_this.listMenuForm.isBlack) {
        param = {
          ...param,
          blackList: Number(_this.listMenuForm.isBlack)
        };
      }
      if (_this.sortValue !== "") {
        param = {
          ...param,
          [_this.sortType]: _this.sortValue
        };
      }else{
        param = {
          ...param,
          sameTypeOrder:1
        };
      }
      _this
        .$post(
          `/request/apply/confirm/list?page=${_this.currentPage}&size=${_this.currentPageSize}`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.tableData = res.data.list;
            _this.total = res.data.allRow;
            _this.paymessage.noPayNumber = res.data.noPayNumber;
            _this.paymessage.payNumber = res.data.payNumber;
            _this.paymessage.orderOutTime = res.data.orderOutTime;
            _this.paymessage.free = res.data.free;
            _this.paymessage.land = res.data.land;
            _this.paymessage.price = res.data.price;
            _this.paymessage.twdPrice = res.data.twdPrice;
            _this.paymessage.applyStatus = res.data.applyStatus;
            if (res.data.free == 0) {
              _this.activityTable2 = this.activityTable;
            } else {
              _this.activityTable2 = this.activityTable1;
            }
            this.$emit("dataBack", {
              applyName: res.data.applyName,
              applyWay: res.data.applyWay,
              applyStatus: res.data.applyStatus,
              registration: res.data.registration,
              totalNum: res.data.totalNum,
              beSelectedNumber: res.data.beSelectedNumber,
              notSelectedNumber: res.data.notSelectedNumber,
              free: res.data.free,
              land: res.data.land
            });
            if (!_this.BadgeoptionsSum.length) {
              _this.BadgeInit();
            }
          } else {
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.dialogVisible = false;
            });
          }
        });
    },
    BadgeoptionsChange(item, index) {
      let currentlist = [];
      this.BadgeoptionsSum.map(ite => {
        if (ite.name == item) currentlist = ite.detailDtoList;
      });
      this.BadgeLeveloptions[index] = currentlist;
      this.listMenuForm.badge[index].badgeLevel = "";
    },
    search() {
      this.getList();
    },
    reset() {
      this.listMenuForm = {
        userEmail: "",
        time1: "",
        time2: "",
        badge: [
          {
            badgeLevel: "",
            badgeType: ""
          }
        ],

        selectStatus: "",
        selectArea: "",
        areaDetail: "",
        isBlack: ""
      };
      this.BadgeLeveloptions = [{}];
      this.getList();
    },
    navigatetoDetail(item) {
      this.isActivate = true;
      this.$router.push(`/activityDrawDetail?id=${item.id}&isconfirm=1`);
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.getList();
    },
    handleSelect(selection, row) {
      //选中行长度大于0并且当前行在选中行中 checkedTrue为true
      let checkedTrue = selection.length && selection.indexOf(row) !== -1;

      if (!checkedTrue) {
        // 取消勾选,使用filter()方法过滤掉刚刚勾选的那一条数据
        this.checkboxList = this.checkboxList.filter(item => item.id != row.id);
      }
      if (checkedTrue) {
        // 勾选，将刚刚勾选的数据用push()方法放进数组
        this.checkboxList.push(row);
      }
    },
    selectAll(selection) {
      // selection 为当前页面的勾选数组
      if (selection.length > 0) {
        // 全选，将本页面所有（可以勾选的）数据放入自定义的勾选数组里
        const uniqueArray = selection.filter(item1 => {
          return !this.checkboxList.some(item2 => item2.id === item1.id);
        });
        this.checkboxList.push(...uniqueArray);
      } else {
        // 取消全选，将本页面所有（可以勾选的）数据用filter()＋every()方法过滤掉
        this.checkboxList = this.checkboxList.filter(
          item => this.tableData.every(it => it.id != item.id)
          // every方法，数组里面所有数据为真则返回真
        );
      }
    },
    confirmShowModal() {
      this.$post(
        `/request/apply/end/pay?applyId=${this.$route.query.id}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code == "00000") {
          this.confirmshow = false;
          this.dialogVisible = true;
          this.$propMessage("結束付款成功", "success", () => {
            this.dialogVisible = false;
          });
          this.getList();
        } else {
          this.confirmshow = false;
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    //上传文件方法
    uploadModal() {
      this.uoloadModal = true;
    },
    endPay() {
      this.confirmshow = true;
    },
    downloadExcel() {
      window.open(
        "https://start.sanctuarytech.co/resource/excel/black_list_template.xlsx"
      );
    },
    fileChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    successExcel(res, file, fileList) {
      let _this = this;
      if (res.code === "00000") {
        _this.dialogVisible = true;
        _this.uoloadModal = false;
        _this.$propMessage("中選名單更新成功", "success", function() {
          _this.dialogVisible = false;
          _this.getList();
          _this.$refs.excelUpload.clearFiles();
        });
      } else {
        _this.dialogVisible = true;
        _this.$propMessage(res.message, "error", function() {
          _this.dialogVisible = false;
          _this.$refs.excelUpload.clearFiles();
          _this.fileList = [];
        });
      }
    },
    errorExcel(err, file, fileList) {
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function() {
        _this.dialogVisible = false;
      });
    },
    submitupdate() {
      this.$refs.excelUpload.submit();
    },
    //确认黑名单
    blackaddshowModal() {
      let _this = this;
      if (_this.blackendTime == "") {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇禁用時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.blackReason == "") {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入加入黑名單原因", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      let blackendTime = _this.$formatDate(this.blackendTime);
      let list = [];
      this.checkboxList.forEach(item => {
        list.push({ userId: item.userId, applyActivityId: item.id });
      });
      let param = {
        idList: list,
        blackListContent: _this.blackReason,
        downTime: blackendTime,
        applyId: this.$route.query.id
      };
      _this.blackaddshow = false;
      _this
        .$post(
          `/request/blackMember/apply/batch/saveBlackList`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.dialogVisible = true;
            _this.$propMessage("批量加入黑名單成功", "success", () => {
              _this.checkboxList = [];
              _this.getList();
              _this.dialogVisible = false;
            });
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", () => {
              _this.dialogVisible = false;
              _this.getList();
            });
          }
        });
    },
    selectAreaChange(item) {
      this.listMenuForm.areaDetail = "";
    },
    blackShow() {
      if (!this.checkboxList.length) {
        this.$Mint.Toast("請選擇報名記錄");
        return;
      }
      (this.blackReason = ""),
        (this.blackendTime = ""),
        (this.blackaddshow = true);
    },
    handleSortChange({ column, prop, order }) {
      console.log(column, prop, order);
      if (prop == "num") {
        this.sortType = "numOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "vipStartTime") {
        this.sortType = "vipStartTimeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "vipEndTime") {
        this.sortType = "vipEndTimeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "annualSelectNum") {
        this.sortType = "annualOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      } else if (prop == "sameTypeSelectNum") {
        this.sortType = "sameTypeOrder";
        if (order == "ascending") {
          //升序
          this.sortValue = 0;
        } else if (order == "descending") {
          //降序
          this.sortValue = 1;
        } else {
          this.sortValue = "";
        }
      }
      setTimeout(() => {
        this.getList();
      }, 50);
    },
    handleDownloadExcel() {
      let _this = this;
      let param = {
        applyId: this.$route.query.id,
        status: 1
      };
      if (_this.listMenuForm.userEmail) {
        param = {
          ...param,
          username: _this.listMenuForm.userEmail
        };
      }
      if (_this.listMenuForm.time1 && _this.listMenuForm.time2) {
        let startTime = this.$formatDate(_this.listMenuForm.time1);
        let endTime = this.$formatDate(_this.listMenuForm.time2);
        param = {
          ...param,
          vipStartTime: startTime,
          vipEndTime: endTime
        };
      }
      let badgeId = [];
      if (_this.listMenuForm.badge[0].badgeType) {
        for (let i = 0; i < _this.listMenuForm.badge.length; i++) {
          if (!_this.listMenuForm.badge[i].badgeType) {
            this.dialogVisible = true;
            this.$propMessage("请選擇徽章", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else if (!_this.listMenuForm.badge[i].badgeLevel) {
            this.dialogVisible = true;
            this.$propMessage("選擇徽章後請選擇徽章等級", "error", () => {
              this.dialogVisible = false;
            });
            return;
          } else {
            badgeId.push(_this.listMenuForm.badge[i].badgeLevel);
            param = {
              ...param,
              badgeId: badgeId.toString()
            };
          }
        }
      }

      if (_this.listMenuForm.selectArea) {
        param = {
          ...param,
          district: Number(_this.listMenuForm.selectArea),
          address: _this.listMenuForm.areaDetail
            ? _this.listMenuForm.areaDetail
            : null
        };
      }
      if (_this.listMenuForm.isBlack) {
        param = {
          ...param,
          blackList: Number(_this.listMenuForm.isBlack)
        };
      }
      let url = "/request/apply/export/excel/status";
      let date = new Date();
      _this.$exportExcel(
        url,
        "POST",
        param,
        "中選名單" + this.$formatDate(date).substring(0, 10)
      );
    }
  },
  components: {
    DiaMess
  },
  watch: {
    tableData: {
      deep: true,
      handler(newValue, oldValue) {
        const arr = newValue.filter(
          item => this.checkboxList.some(it => it.id === item.id)
          // some()方法，数组里有一个为真则返回真
        );
        this.$nextTick(() => {
          // 要用nextTick(()={})去更新页面
          arr.forEach(row => {
            // 将数据进行回显
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        });
      }
    },
    uoloadModal(newValue, oldValue) {
      if (newValue === false) {
        this.fileList = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-table__fixed-right .el-table__fixed-body-wrapper {
  top: 48px !important;
}
.el-icon-circle-plus-outline {
  font-size: 20px;
  cursor: pointer;
}

.el-icon-circle-plus-outline::before {
  position: relative;
  top: 2px;
}
.content {
  .paddingContent {
    width: 100%;
    // overflow: auto;
    .activityDrawListSearch {
      width: 100%;
      .ListMenu {
        display: flex;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
        margin-top: 2px;
      }
      .MenuBtnWrap_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .activityDrawListTag {
      background: rgba(250, 250, 253, 1);
      display: flex;
      align-items: center;
      padding: 16px;
      border-radius: 5px;
      margin-top: 26px;
      .activityDrawListTag_detail_key {
        margin-left: 24px;
        font-size: 14px;
        color: rgba(147, 142, 164, 1);
      }
      .activityDrawListTag_detail_value {
        font-size: 17px;
        color: rgba(41, 41, 41, 1);
      }
    }
    .statusbar_top {
      font-size: 14px;
      color: #000;
      font-weight: 500;
      margin-left: 25px;
    }
    .activityDrawListTable {
      border-radius: 5px;
      margin-top: 10px;
      .statusbar {
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .statusbar_left {
          display: flex;
          align-items: center;
          div {
            font-size: 14px;
          }
          div:nth-child(1) {
            color: rgba(41, 41, 41, 1);
          }
        }
        .statusbar_right {
          display: flex;
          align-items: center;
          .btnPur {
            background: none;
            color: rgba(105, 62, 221, 1);
            border: 1px solid rgba(105, 62, 221, 1);
            margin-right: 20px;
          }
        }
      }
    }
    .remark_box_input {
      position: relative;
      margin-top: 30px;
    }
    .remark_box_text {
      position: absolute;
      z-index: 10;
      // color: #292929;
      left: 20px;
      line-height: 46px;
      // font-size: 0.14rem;
    }
  }
}
/deep/ .el-textarea__inner {
  text-indent: 50px;
}
/deep/ .el-dialog {
  border-radius: 12px;
}
/deep/ .el-dialog__header {
  //   box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
/deep/ .el-dialog__title {
  font-size: 0.16rem;
}
/deep/ .el-upload__text em {
  color: #6c3dea !important;
}
/deep/ .el-upload-dragger:hover {
  border-color: #6c3dea !important;
}
/deep/ .el-upload-dragger {
  width: 320px !important;
  border: 1px dashed #d9d9d9 !important;
}
.dialog {
  display: flex;
  justify-content: center;
  .el-upload__tip {
    color: #65676b;
  }
  .dialogrow {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /deep/ .el-checkbox {
      width: 110px !important;
      text-align: left;
      display: block !important;
    }
    /deep/ .el-input {
      width: 190px !important;
    }
    .badgeadd {
      width: 80px;
      color: rgba(147, 144, 163, 1);
      background: rgba(242, 240, 247, 1);
      text-align: center;
      cursor: pointer;
      line-height: 36px;
      margin-left: 9px;
      border-radius: 6px;
    }
    .badgedelete {
      width: 80px;
      text-align: center;
      color: #6c3dea;
      line-height: 36px;
      margin-left: 9px;
      cursor: pointer;
    }
  }
  .btngroup {
    margin-top: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      text-align: center;
    }
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityConfirm.vue